import { usersOwnRecent } from '@/api/core/users/usersOwnRecent';
import { useHeadersSuspenseQuery } from '@/hooks/useHeadersSuspenseQuery';

export const useUserRecentFlights = () => useHeadersSuspenseQuery({
    queryKey: ['userRecentFlights'],
    queryFn: (_, headers) => usersOwnRecent(headers).then(r => r.payload)
});
